import { render, staticRenderFns } from "./SimpleRequisiteDataSelect.vue?vue&type=template&id=438eba8a&scoped=true&"
import script from "./SimpleRequisiteDataSelect.vue?vue&type=script&lang=js&"
export * from "./SimpleRequisiteDataSelect.vue?vue&type=script&lang=js&"
import style0 from "./SimpleRequisiteDataSelect.vue?vue&type=style&index=0&id=438eba8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438eba8a",
  null
  
)

export default component.exports